import { Event, EventApi } from 'api'
import { TopLevelPage, ModelGrid } from 'ui'
import { withErrorBoundary, connected } from 'shared'

const Events = ({ match }) => {
  const { listId, id } = match.params
  const params = Event.parseEventListId(listId)
  const models = EventApi.kick('list', params)
  const base = `events/${listId}`

  return (
    <TopLevelPage className="Events" modelId={id} base={'/' + base}>
      <ModelGrid models={models} base={base} />
    </TopLevelPage>
  )
}

export default withErrorBoundary(connected(Events))
